<div class="genie-content-card">

  <!-- ── Users Table ─────────────────────────────────────────────── -->
  <div class="table-section">

    <!-- Toolbar -->
    <div class="genie-toolbar">
      <div class="toolbar-left">
        <div class="search-input-wrapper">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <input
            type="text"
            placeholder="{{ 'Search' | translate }}"
            [(ngModel)]="searchText"
            [ngModelOptions]="{ standalone: true }"
            (input)="applyFilter()"
          />
        </div>
      </div>
    </div>

    <!-- Users Table -->
    <div class="genie-table-wrapper">
      <table class="genie-table">
        <thead>
          <tr>
            <th>{{ 'User Name' | translate }}</th>
            <th>{{ 'Email' | translate }}</th>
            <th class="col-center">{{ 'Points' | translate }}</th>
            <th class="col-center">{{ 'Redeem' | translate }}</th>
            <th class="col-center">{{ 'Date' | translate }}</th>
            <th class="col-center">{{ 'Transactions History' | translate }}</th>
          </tr>
        </thead>
        <tbody class="users_table">
          <tr *ngFor="let element of displayedUsers" [class.selected-row]="selectedUser === element">
            <td>{{ element.nickname || element.name }}</td>
            <td>{{ element.email }}</td>
            <td class="col-center">{{ element.totalPoints }}</td>
            <td class="col-center">{{ element.redeem || '-' }}</td>
            <td class="col-center">{{ element.lastInitialDate }}</td>
            <td class="col-center">
              <button class="genie-icon-btn view" (click)="showUserHistory(element)">
                <img src="assets/icons/Frame.svg" alt="history" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Users Pagination -->
    <div class="genie-pagination">
      <div class="pagination-info">
        <span class="current-page">{{ userPageIndex + 1 }}</span>
        <span class="page-separator">{{ 'of' | translate }}</span>
        <span class="total-pages">{{ getUserTotalPages() }}</span>
      </div>
      <div class="pagination-controls">
        <button class="page-btn prev" [disabled]="userPageIndex === 0" (click)="userPrevPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <button class="page-btn next" [disabled]="userPageIndex >= getUserTotalPages() - 1" (click)="userNextPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>

  </div>

  <!-- ── Transaction History Panel ──────────────────────────────── -->
  <div *ngIf="selectedUser" class="history-panel">

    <!-- Panel Header -->
    <div class="history-panel-header">
      <h3>{{ 'Transactions History' | translate }} — {{ selectedUser.nickname || selectedUser.name }}</h3>
      <div class="history-actions">
        <button class="genie-btn primary" (click)="addPoints()">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          {{ 'Add Points' | translate }}
        </button>
        <input
          *ngIf="toAddPoints"
          class="points-input"
          type="number"
          [(ngModel)]="newPoints.points"
          [ngModelOptions]="{ standalone: true }"
          (blur)="saveChanges(selectedUser)"
          placeholder="0"
          autofocus
        />
      </div>
    </div>

    <!-- No History -->
    <p *ngIf="!selectedUser.pointsArray" class="no-history">
      {{ 'User has no history' | translate }}
    </p>

    <!-- History Table -->
    <ng-container *ngIf="selectedUser.pointsArray">
      <div class="genie-table-wrapper">
        <table class="genie-table">
          <thead>
            <tr>
              <th>{{ 'Date' | translate }}</th>
              <th class="col-center">{{ 'Earned' | translate }}</th>
              <th class="col-center">{{ 'Redeemed' | translate }}</th>
              <th class="col-actions"></th>
            </tr>
          </thead>
          <tbody class="users_table">
            <tr *ngFor="let point of displayedHistory">
              <td>{{ point.initialDate }}</td>
              <td class="col-center">{{ point.points > 0 ? point.points : '0' }}</td>
              <td class="col-center">{{ point.points < 0 ? point.points : '0' }}</td>
              <td class="col-actions">
                <div class="genie-action-buttons">
                  <button class="genie-icon-btn delete" (click)="deletePoint(selectedUser, point)">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.53438 3.13438V2.65438C8.53438 1.98231 8.53438 1.64628 8.40358 1.38959C8.28854 1.16379 8.10496 0.980215 7.87916 0.865167C7.62247 0.734375 7.28644 0.734375 6.61438 0.734375H5.65438C4.98231 0.734375 4.64628 0.734375 4.38959 0.865167C4.16379 0.980215 3.98022 1.16379 3.86517 1.38959C3.73438 1.64628 3.73438 1.98231 3.73438 2.65438V3.13438M4.93438 6.43438V9.43438M7.33438 6.43438V9.43438M0.734375 3.13438H11.5344M10.3344 3.13438V9.85438C10.3344 10.8625 10.3344 11.3665 10.1382 11.7516C9.96562 12.0903 9.69025 12.3656 9.35156 12.5382C8.96652 12.7344 8.46247 12.7344 7.45438 12.7344H4.81438C3.80628 12.7344 3.30223 12.7344 2.91719 12.5382C2.5785 12.3656 2.30314 12.0903 2.13056 11.7516C1.93437 11.3665 1.93438 10.8625 1.93438 9.85438V3.13438" stroke="#ADADAD" stroke-width="1.467" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- History Pagination -->
      <div class="genie-pagination">
        <div class="pagination-info">
          <span class="current-page">{{ historyPageIndex + 1 }}</span>
          <span class="page-separator">{{ 'of' | translate }}</span>
          <span class="total-pages">{{ getHistoryTotalPages() }}</span>
        </div>
        <div class="pagination-controls">
          <button class="page-btn prev" [disabled]="historyPageIndex === 0" (click)="historyPrevPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <button class="page-btn next" [disabled]="historyPageIndex >= getHistoryTotalPages() - 1" (click)="historyNextPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </ng-container>

  </div>

</div>
